import type { JsonApiResponse, JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import type { RequestConfig } from 'api/types';

import { clientCaseFactFindLetterOfAuthorityTrackingLoaRequestApi } from './loaRequest';

export interface ClientCaseFactFindLetterOfAuthorityTrackingPostOptions {
  assetNumber: number;
  providerName: string;
  // Optional: set only when the record is opened against a directory provider
  // (Cluster 03 Component A). Manual create-on-issue omits it.
  providerId?: number;
  notes?: string;
}

export type ClientCaseFactFindLetterOfAuthorityTrackingGetResponse = JsonApiResponse;
export type ClientCaseFactFindLetterOfAuthorityTrackingPostResponse = JsonApiResponseSingle;

export function clientCaseFactFindLetterOfAuthorityTrackingApi(path: string) {
  return {
    path,
    loaRequest: (id: number | string) =>
      clientCaseFactFindLetterOfAuthorityTrackingLoaRequestApi(`${path}/${id}`),
    GET: (config?: RequestConfig) =>
      api.get<ClientCaseFactFindLetterOfAuthorityTrackingGetResponse>(path, config),
    POST: ({
      assetNumber,
      providerName,
      providerId,
      notes,
    }: ClientCaseFactFindLetterOfAuthorityTrackingPostOptions) =>
      api.post<ClientCaseFactFindLetterOfAuthorityTrackingPostResponse>(path, {
        data: {
          attributes: {
            asset_number: Number(assetNumber),
            provider_name: providerName,
            provider_id: providerId,
            notes,
          },
        },
      }),
  };
}
